import { IconSet } from '@postscript/components';
import { useMemo } from 'react';

import { PERMISSIONS } from 'components/account/AccountView/users/constants';
import { ENTITLEMENTS_INTEGRATIONS } from 'components/admin/utils/feature-flags';
import { NavMenuItem } from 'components/navigation/NavMenu';
import { usePSLabs } from 'controllers/contexts/labsFeatures';

export const useIntegrationsMenuItems = () => {
  const { hasLabsFlag } = usePSLabs();
  const hasEntitlementsFlag = hasLabsFlag(ENTITLEMENTS_INTEGRATIONS);

  return useMemo(
    (): NavMenuItem[] => [
      {
        id: 'integrations',
        label: 'Integrations',
        icon: IconSet.Apps,
        isLoading: false,
        ariaLabelledBy: 'nav-integrations-title',
        restrictions: [PERMISSIONS.limit_sms_sales_agent_access],
        subMenu: [
          {
            link: '/integrations',
            label: 'All',
            id: 'integrations-all',
            entitlementKey: hasEntitlementsFlag
              ? 'integrations::browse'
              : undefined,
          },
          {
            link: '/fondue',
            label: 'Fondue',
            id: 'fondue',
            tag: { content: 'New' },
            entitlementKey: hasEntitlementsFlag
              ? 'integrations::fondue::setup'
              : undefined,
          },
        ],
      },
    ],
    [hasEntitlementsFlag],
  );
};
